import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';
import { usePanelAccess } from '../../context/PanelAccessContext';
import PanelHubGrid, { HubCardItem } from '../../components/PanelHubGrid';

const ALL_CARDS: (HubCardItem & { referentFunctions?: string[] })[] = [
  {
    to: '/panel/scenarios',
    title: 'Scenarios & CTA',
    description: 'CTA en cours, creer/gerer les scenarios, categories et messages radio ANTARES.',
    accent: 'violet',
  },
];

const PanelScenaristeHubV1: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { loading, hasAccessToSection, hasReferentFunction } = usePanelAccess();
  const roleId = currentUser?.roles_id ?? 0;
  const canEnterHub = hasAccessToSection('salon_scenariste');

  useEffect(() => {
    if (!loading && currentUser && !canEnterHub) {
      navigate('/panel/dashboard', { replace: true });
    }
  }, [loading, currentUser, canEnterHub, navigate]);

  const cards = useMemo(() => {
    return ALL_CARDS.filter((c) => {
      if (!c.referentFunctions || c.referentFunctions.length === 0) return true;
      if (roleId === 1) return true;
      return c.referentFunctions.some((fn) => hasReferentFunction(fn));
    });
  }, [hasReferentFunction, roleId]);

  if (!currentUser || loading || !canEnterHub) {
    return null;
  }

  return (
    <PanelHubGrid
      description="Tous les outils scenarios sont regroupes dans une seule page a onglets."
      cards={cards}
    />
  );
};

export default PanelScenaristeHubV1;
